<template>
  <div>
      <div class="mainHead">
        <div class="route">
          <span class="crumbs"></span><span class="link" @click="returnBtn">监测点管理</span><span class="arrow">></span><span>删除成功</span>
        </div>
        <div> 
          <el-button type="primary" @click="returnBtn">返回</el-button>
        </div>
      </div>
      <div class="fixedScroll" :style="{height: heightCard + 'px'}">
        <div class="maindetails">
            <div class="save">
                <div class="saveIcon"><img src="../../assets/img/delete.png" alt=""><span>删除成功!</span></div>
                <div class="savetimer">( {{count}} ) 秒后自动返回监测点管理</div>
                <div class="saveBtn">
                    <div @click="returnIndex"><el-button type="primary">立刻返回监测点管理</el-button></div>
                </div>
            </div>
        </div>
     </div>
  </div>
</template>

<script>
    export default {
        name: 'saveSuccessfully',
        components: {

        },
        data() {
            return {
              count:'',
              heightCard:''
            }
        },
        created() {
            this.settime();
        },
        mounted() {
            let that = this;
            function initFont() {
                that.heightCard = $(document.body).height() - $('.el-header').outerHeight(true)- $('.mainHead').outerHeight(true) -20;
                that.heightBg =  that.heightCard -$('.maindetails').outerHeight(true);
            }initFont();
            $(window).resize(initFont);
        },
        methods: {
            settime(){
                const TIME_COUNT = 5;
                if(!this.timer){
                    this.count = TIME_COUNT;
                    this.timer = setInterval(()=>{
                        if(this.count > 0 && this.count <= TIME_COUNT){
                            this.count--;
                        }else{
                            clearInterval(this.timer);
                            this.timer = null;
                            this.$router.push({path:'/content/BasicData'}); //监测点首页
                        }
                    },1000)
                }
            },
            returnBtn(){ //返回按钮;
                clearInterval(this.timer);
                this.$router.push({path:'/content/BasicData'}); //监测点首页
            },
            returnIndex(){
                clearInterval(this.timer);
                this.$router.push({path:'/content/BasicData'}); //监测点首页
            }
        }
    }
</script>

<style scoped lang="scss">
@import "@/assets/css/mixin.scss";
// 内容布局
.el-main{
  width: 78.1%;
  margin:10px 0 7px 1.05%;
  padding: 0;
  .maindetails{
      height: 100%;
      padding-top: 145px;
      margin-right: 1.05%;
      background-color:#fff;
  }
}
.save{
    .saveIcon{
        @include flexible;
        @include alignItems(center);
        @include justify(center);
        font-size: 28px;
        color: #282828;
        font-weight: bold;
        &>span{
            margin-left: 10px;
            display: inline-block;
            vertical-align: middle
        }
        img{
            width: 36px;
            height: 36px;
        }
    
    }
    .savetimer{
        margin-top: 20px;
        font-size: 13px;
        color: #282828;
        @include flexible;
        @include alignItems(center);
        @include justify(center);
    }
    .saveBtn{
        margin-top: 30px;
        @include flexible;
        @include alignItems(center);
        @include justify(center);
        .el-button{
            width: 200px;
            height: 40px;
            padding: 0;
            font-size: 16px !important;
        }
        &>div{
            margin-right: 20px;
            &:last-child{
                margin-right: 0;
            }
        }
    }
}

</style>


// WEBPACK FOOTER //
// src/page/BasicData/deleteSuccessfully.vue